import { useEffect, RefObject } from "react";

export const useBlockElementScroll = (scrollRef: RefObject<HTMLElement | null>) => {
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handleWheel = (e: WheelEvent) => {
      e.preventDefault();
      window.scrollBy(0, e.deltaY);
    };

    el.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      el.removeEventListener("wheel", handleWheel);
    };
  }, [scrollRef]);
};
